import { Component, Input, OnInit } from '@angular/core';
import {
  CardConfiguration,
  IBillingDocument,
  transactionService,
} from '@dch/billing-business-logic';
import { TranslationService } from '@dch/ng-common';

@Component({
  selector: 'my-bill-odb-bill-document-info',
  templateUrl: './odb-bill-document-info.component.html',
  standalone: false,
})
export class OdbBillDocumentInfoComponent implements OnInit {
  @Input() billingDocument: IBillingDocument;
  @Input() customTitle: string;
  transactionConfiguration?: CardConfiguration;

  constructor(private translationService: TranslationService) {}

  ngOnInit() {
    this.transactionConfiguration = transactionService.configureCard(
      this.billingDocument,
      (key) => this.translationService.getTranslatedValueFor(key)
    );
  }
}
